/**
 * EventLogSection — rolling event log (recent race:* + gmEvent* events).
 */

import React from 'react';
import type { RaceDebugLogEntry } from '../../../../systems/race/RaceDebugOverlayState';
import { Section, Row, LogEntry } from '../RaceDebugPrimitives';

const COLOR = '#aaaaaa';
const MAX_DISPLAY = 8;

export const EventLogSection: React.FC<{
  log: RaceDebugLogEntry[];
}> = ({ log }) => (
  <Section title={`Event Log (${log.length})`} color={COLOR}>
    {log.length === 0
      ? <Row label="—" value="no events yet" valueColor="#666" />
      : log.slice(-MAX_DISPLAY).reverse().map((entry, i) => (
        <LogEntry key={i} ts={entry.ts} type={entry.type} summary={entry.summary} />
      ))}
  </Section>
);
